module.exports = vendor_40d98c73d8d5ea86e9ab;